import React from 'react';
import {
	Wrapper,
	TextContainer,
	Text,
	ScrollContainer,
} from './NoData.styles';

export const NoData = ({ message }) => (
	<ScrollContainer>
		<Wrapper>
			<TextContainer>
				<Text>{message}</Text>
			</TextContainer>
		</Wrapper>
	</ScrollContainer>
);
